import xmldom from 'xmldom'
import { createElement } from 'react'
import { getKey } from '@healthwise-ui/core/KeyGen'

export default class ComponentBuilder {
  constructor (options) {
    this.options = options || {}

    this.componentMap = this.options.componentMap || []

    this.attributeMapping = {
      'class': 'className',
      'for': 'htmlFor',
      'http-equiv': 'httpEquiv',
      'crossorigin': 'crossOrigin',
      'srclang': 'srcLang',
      'accesskey': 'accessKey'
    }

    this.selfClosingTags = {
      'area': true,
      'base': true,
      'br': true,
      'col': true,
      'embed': true,
      'hr': true,
      'img': true,
      'input': true,
      'keygen': true,
      'link': true,
      'meta': true,
      'param': true,
      'source': true,
      'track': true,
      'wbr': true
    }
  }

  build (html) {
    const parser = new xmldom.DOMParser()
    const root = parser.parseFromString(html, 'text/html')
    return this.getReactComponent(root.childNodes['0'])
  }

  getReactComponent (root) {
    if (root.childNodes) {
      const componentInfo = this.getComponentInfoFromNode(root)
      if (componentInfo !== null) {
        if (componentInfo.selfClosing) {
          return createElement(componentInfo.use, this.getProps(root, componentInfo.withProps))
        }
        return createElement(componentInfo.use, this.getProps(root, componentInfo.withProps), this.getChildren(root.childNodes))
      }
    }
    return null
  }

  getComponentInfoFromNode (node) {
    for (const mapItem of this.componentMap) {
      if (typeof mapItem.when === 'function' && mapItem.when(node)) {
        if (mapItem.ignore) {
          return null
        }
        return {use: mapItem.use, withProps: mapItem.withProps || {}, selfClosing: mapItem.selfClosing || false}
      }
    }

    const tagName = (node.tagName || '').toLowerCase()
    return {use: tagName, withProps: {}, selfClosing: this.selfClosingTags[tagName] || false}
  }

  getChildren (children) {
    let childComponents = []
    for (var key in children || {}) {
      if (children.hasOwnProperty(key)) {
        let node = children[key]
        if (node.data) {
          childComponents.push(this.removeExtraSpaces(node.data))
        } else if (node.tagName) {
          childComponents.push(this.getReactComponent(node))
        }
      }
    }
    return childComponents
  }

  getProps (node, defaultProps = {}) {
    let props = {key: getKey()}
    if (node.attributes && node.attributes.length !== 0) {
      for (let key in node.attributes) {
        if (node.attributes.hasOwnProperty(key)) {
          const attribute = node.attributes[key]

          if (attribute.nodeName !== attribute.tagName) {
            const attributeName = this.attributeMapping[attribute.nodeName] || attribute.nodeName
            props[attributeName] = attribute.nodeValue
          }
        }
      }
    }
    return Object.assign(defaultProps, props)
  }

  removeExtraSpaces (data) {
    return (data || '').replace(/\r?\n|\r/g, ' ').replace(/\s+/g, ' ')
  }
}



// WEBPACK FOOTER //
// /src/~/@healthwise/enhanced-shared-decision-point/archetypes/ComponentBuilder/index.js